import { AttendanceDay } from './attendance-day.model';
import { AttendanceStatusItem } from './attendance-status-item.model';

export class StudentsAttendances {
  isBilled: boolean;
  billingDate: Date;
  billingUser: string;
  isValidated: boolean;
  validateDate: Date;
  validateUser: string;
  studentAttendances: StudentAttendance[];
}

export class StudentAttendance {
  studentId: number;
  studentCau: string;
  studentName: string;
  studentLastName: string;
  schoolarCourseId: number;
  schoolarCourse: string;
  schoolarshipId: number;
  schoolarshipName: string;
  studentContractType: string;
  familyId: number;
  familyAccount: string;
  customerNumber: string;
  attendanceCount: number;
  hasDiscount1: boolean;
  hasDiscount2: boolean;
  hasDiscount3: boolean;
  attendanceDays: AttendanceDay[];
}

export class WorkingStudentAttendance {
  index: number;
  studentId: number;
  exerciseId: number;
  familyId: number;
  studentCau: string;
  studentName: string;
  studentLastName: string;
  schoolarCourseId: number;
  schoolarCourse: string;
  schoolarshipId: number;
  schoolarshipName: string;
  studentContractType: string;
  familyAccount: string;
  customerNumber: string;
  attendanceCount: number;
  hasDiscount1: boolean;
  hasDiscount2: boolean;
  hasDiscount3: boolean;
  attendanceDays: AttendanceStatusItem[];
  isProcessing: boolean;
  isEdited: boolean;
}

export class StudentAttendanceResponse {
  isValidated: boolean;
  studentAttendances: StudentAttendance[];
  validateDate: Date;
  validateUser: string;
}
